import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-226a2cf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "wrapper" }
const _hoisted_2 = { id: "header-section" }
const _hoisted_3 = { class: "feedback-base-card" }
const _hoisted_4 = {
  key: 0,
  class: "card-header"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "first-line" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "card-main-content" }
const _hoisted_9 = { class: "card-text" }
const _hoisted_10 = { class: "icons-container" }
const _hoisted_11 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['comment-number', 'positive'])
}
const _hoisted_12 = { class: "card-details" }

import { ref, computed } from 'vue'
import type { Ref } from 'vue'
import { IResponse } from '@/entities'
import Typography from '@/components/Rain/Typography/Typography.vue'
import Carousel from '@/components/Rain/Layouts/Carousel/Carousel.vue'
import ResponseCircle from '@/components/ResponseCircle.vue'
import TextClamp from '@/components/TextClamp.vue'
import { getCommentCount } from '@/mobile/src/utils/feedback'
import { relativeDate } from '@/utils/time'
import { pendoTrackEvent } from '@/utils/pendo'

interface Props {
    header: string
    feedback?: IResponse[] | null
    onFeedbackClickCallback?: (id) => void
    viewAllCallback?: () => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackCardCarousel',
  props: {
    header: {},
    feedback: { default: null },
    onFeedbackClickCallback: { type: Function, default: () => ({}) },
    viewAllCallback: { type: Function, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props

const currentSlideIndex: Ref<number> = ref(0)

function carouselSlide(previous: number, newSlide: number): void {
    currentSlideIndex.value = newSlide
}

function onViewAllClick(): void {
    pendoTrackEvent('latest-feedback-view-all-clicked')
    props.viewAllCallback()
}

function onFeedbackClick(feedbackId: number): void {
    props.onFeedbackClickCallback(feedbackId)
}

function getPersonName(response: IResponse): string {
    return response.person?.name ?? 'Anonymous'
}

function getCommentText(response: IResponse): string {
    return hasComment(response) ? response.comment : 'No comment'
}

function hasComment(response: IResponse): boolean {
    return !!response.comment?.length
}

const hasScorecardBadges = computed(() => {
    return props.feedback
        ? props.feedback[currentSlideIndex.value]?.badges?.length
        : false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Typography, {
        class: "header",
        variant: "overline"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.header), 1)
        ], undefined, true),
        _: 1
      }),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = () => onViewAllClick())
      }, [
        _createVNode(Typography, {
          class: "view-all",
          variant: "overline"
        }, {
          default: _withCtx(() => [
            _createTextVNode("View All")
          ], undefined, true),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (hasScorecardBadges.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(Typography, {
              variant: "overline",
              class: "title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.feedback[currentSlideIndex.value].badges[0].label), 1)
              ], undefined, true),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(Carousel, {
        class: "feedback-carousel",
        onSlidechanged: carouselSlide
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.feedback, (response) => {
            return (_openBlock(), _createElementBlock("div", {
              key: response.id,
              class: "card-content flicking-panel",
              onClick: () => onFeedbackClick(response.id)
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(ResponseCircle, {
                    score: Number(response.answer),
                    variation: response.question_type
                  }, null, 8, ["score", "variation"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(Typography, {
                      variant: "body2",
                      class: _normalizeClass({ italics: !hasComment(response) })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TextClamp, {
                          "is-html": "",
                          text: getCommentText(response),
                          "max-lines": 2
                        }, null, 8, ["text"])
                      ], undefined, true),
                      _: 2
                    }, 1032, ["class"]),
                    _createElementVNode("div", _hoisted_10, [
                      (_unref(getCommentCount)(response) > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(getCommentCount)(response)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(Typography, {
                      variant: "overline",
                      class: "card-author"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getPersonName(response)), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024),
                    _createVNode(Typography, {
                      variant: "overline",
                      class: "timestamp"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(relativeDate)(Number(response.responded))), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024)
                  ])
                ])
              ])
            ], 8, _hoisted_5))
          }), 128))
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})